import { Map, Record } from 'immutable';

import CompanyRecord from 'records/company';

export const proDomains = [
    'snagshout.com',
    'massview.com',
    'snagshout.co',
    'fuseserv.com',
    'getyour.promo',
];

const MeRecord = Record({
    canPro: false,
    company: CompanyRecord(Map({})),
    createdAt: '',
    email: '',
    facebookAccount: Map({}),
    firstName: '',
    fullName: '',
    id: null,
    isAdmin: false,
    lastName: '',
    loggedInAt: '',
    metadata: Map({}),
});

function getHasBetaAccess() {
    return this.get('isAdmin', false) || this.get('company').getHasBetaAccess();
}

function getMetadata() {
    return this.get('metadata', Map({}));
}

function getCanPro() {
    return this.get('isAdmin', false) || Boolean(proDomains.find((e) => this.get('email').endsWith(e)));
}


MeRecord.prototype.getHasBetaAccess = getHasBetaAccess;
MeRecord.prototype.getCanPro = getCanPro;
MeRecord.prototype.getMetadata = getMetadata;

export default MeRecord;
